import uniqid from 'uniqid'
import { currentProject } from '../../portfolio'
import ProjectContainer from '../ProjectContainer/ProjectContainer'
import '../Projects/Projects.css'

const CurrentProject = () => {

  return (
    <section id='projects' className='section projects'>
      <h2 className='section__title'>Currently Working On</h2>
      <div className='projects__grid'>
          <ProjectContainer key={uniqid()} project={currentProject} />
      </div>
    </section>
  )
}

export default CurrentProject
